<template>
	<div>
		<ValidationDialog
			:ShowModal="ShowModal"
			:RouteUrl="RouteUrl"
			:DisplayMessage="DisplayMessage"
		></ValidationDialog>
		<SenderEmailUpdateDialog
			:ShowModal="showEmailUpdateModal"
			@onemailupdated="onEmailSubmitted"
		>
		</SenderEmailUpdateDialog>

		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">E-Invoice</h2>
			</div>
		</div>
		<div class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<div class="row">
						<div class="col-sm-5">Date: {{ currentDate }}</div>
						<div class="col-sm-4"></div>
						<div class="col-sm-3">
							<button
								type="button"
								class="btn btn-primary"
								ref="btnGenerateEInvoice"
								@click="onGenerateEInvoice"
								:disabled="!hasSelectedRows"
							>
								Generate E-Invoice
							</button>
						</div>
					</div>
					<br />
					<img
						src="/static/img/icons/arrow-down-indicator-red.png"
						alt=""
						class="top-indicator"
					/>

					<kendo-grid
						ref="EInvoiceGrid"
						:data-source="kendoDataSource"
						:pageable="true"
						:sortable="true"
						:pagable="pageable"
						:columns="columns"
						:no-records="true"
						:filterable="filterable"
						@databound="onDataBound"
					>
					</kendo-grid>
				</div>
			</div>
		</div>

		<div v-if="showPopup" class="popup">
			<div class="popup-content">
				<h4 class="mb-4">Hi, {{ FullName }}</h4>
				<p class="mb-3">
					Help us secure your E-Invoice Request by verifying that
					<strong>{{ userEmail }}</strong> is your email address
					registered under eRemit.
				</p>
				<p class="mb-4">
					Click the Confirm Email Address button below if the email is
					already registered under eRemit and E-Invoice will be sent
					into your email.
				</p>

				<div class="button-group">
					<button class="button confirm" @click="confirmEmail">
						Confirm Email Address
					</button>
					<p class="update-email-text">
						If not your email or need to update your email, please
						click on Update Email Address Button
					</p>
					<button class="button update" @click="updateEmail">
						Update Email Address
					</button>
					<button class="button" @click="closePopup">
						Close
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Base from "../../shared/Base.vue";
import ListService from "../../services/list";
import kendo from "@progress/kendo-ui";
import ValidationDialog from "../../shared/ValidationDialog.vue";
import SenderEmailUpdateDialog from "../../shared/SenderEmailUpdate.vue";
import moment from "moment";
import CommonService from "../../services/common";

export default {
	name: "transactionHistory",
	extends: Base,
	components: {
		ValidationDialog,
		SenderEmailUpdateDialog
	},
	created() {
		this.url.list = "einvoice/transaction/list";
		if (kendo.ExternalFilter) delete kendo.ExternalFilter;
		const userDetails = CommonService.getUserDetailInformation();
		this.userEmail = userDetails.EmailAddress;
		this.FullName = userDetails.FullName;
	},
	data() {
		return {
			showPopup: false,
			selectedIds: [],
			ShowModal: false,
			RouteUrl: null,
			DisplayMessage: "",
			userEmail: "",
			FullName: "",
			isProcessing: false,
			currentDate: moment().format("YYYY/MM/DD"),
			columns: [
				{
					title: "Select",
					template: function(dataItem) {
						const disabled = !dataItem.CanRequestEInvoice;
						const disabledAttr = disabled ? "disabled" : "";
						const disabledClass = disabled
							? "checkbox-disabled"
							: "";
						return `<input type="checkbox"
              class="transaction-checkbox ${disabledClass}"
              data-id="${dataItem.Id}"
              ${disabledAttr}
              data-can-request="${dataItem.CanRequestEInvoice}">`;
					},
					headerTemplate:
						'<input type="checkbox" id="selectAll" class="select-all-checkbox">',
					width: 70
				},
				{
					title: "Transaction Reference",
					template: function(dataItem) {
						return `
							<div class="transaction-ref">
          <div class="txn-link" style="color: #337ab7; font-weight: bold;">${dataItem.TransactionRefNo}</div>
          <div class="beneficiary-name">${dataItem.BeneficiaryName}</div>
        </div>
						`;
					}
				},
				{
					title: "Transfer Fee",
					template: function(dataItem) {
						const statusColor =
							dataItem.EInvoiceSubmitStatus.toLowerCase() ===
							"failed"
								? "red"
								: "orange";
						return `
              <div>MYR ${dataItem.TransferFees}</div>
              <div class="einvoice-status" style="color: ${statusColor}">
                ${dataItem.EInvoiceSubmitStatus}
              </div>
            `;
					}
				},
				{
					title: "Created On",
					field: "CreatedOn",
					filterable: false
				},
				{
					title: "Paid Date",
					field: "PaidDate",
					filterable: false
				},
				{
					title: "Status",
					field: "Status"
				}
			]
		};
	},
	computed: {
		hasSelectedRows() {
			return this.selectedIds.length > 0;
		}
	},
	methods: {
		onGenerateEInvoice() {
			if (this.hasSelectedRows) {
				this.showPopup = true;
			} else {
				this.$toastr(
					"error",
					"Please select at least one transaction."
				);
			}
		},

		closePopup() {
			if (!this.isProcessing) {
				this.showPopup = false;
			}
		},

		async confirmEmail() {
			const self = this;
			if (self.isProcessing) return;

			try {
				self.isProcessing = true;
				const payload = {
					TransactionList: self.selectedIds.map(id => ({ Id: id }))
				};

				await self.$http.post("einvoice/generate", payload);
				self.showPopup = false;
				self.$toastr("success", "Submission Successful! Thank you for your submission e-Invoice. You may expect a 2-3 working day time and will submit in your email.");
				self.refreshGrid("EInvoiceGrid");
				self.selectedIds = [];
			} catch (error) {
				//self.$toastr(
				//	"error",
				//	error.response?.data?.message ||
				//		"Failed to generate E-Invoice"
				//);
			} finally {
				self.isProcessing = false;
			}
		},

		updateEmail() {
			if (!this.isProcessing) {
				this.showPopup = false;
				this.$router.push("/changeemail");
			}
		},

		onDataBound(e) {
			const self = this;
			const grid = e.sender;

			grid.element
				.find(".transaction-checkbox")
				.off("change")
				.on("change", function() {
					const id = parseInt($(this).data("id"));
					const canRequest = $(this).data("can-request");
					if (!id || !canRequest) return;

					if (this.checked) {
						if (!self.selectedIds.includes(id)) {
							self.selectedIds.push(id);
						}
					} else {
						const index = self.selectedIds.indexOf(id);
						if (index > -1) {
							self.selectedIds.splice(index, 1);
						}
					}
				});

			grid.element
				.find(".select-all-checkbox")
				.off("change")
				.on("change", function() {
					const isChecked = this.checked;

					grid.element
						.find(".transaction-checkbox:not([disabled])")
						.each(function() {
							const checkbox = $(this);
							const id = parseInt(checkbox.data("id"));
							const canRequest = checkbox.data("can-request");
							if (!id || !canRequest) return;

							checkbox.prop("checked", isChecked);
							if (isChecked && !self.selectedIds.includes(id)) {
								self.selectedIds.push(id);
							} else if (!isChecked) {
								self.selectedIds = self.selectedIds.filter(
									selectedId => selectedId !== id
								);
							}
						});
				});

			if (this.selectedIds.length > 0) {
				this.selectedIds.forEach(id => {
					const checkbox = grid.element.find(
						`.transaction-checkbox[data-id="${id}"]`
					);
					if (checkbox.length && checkbox.data("can-request")) {
						checkbox.prop("checked", true);
					}
				});
			}

			const totalCheckableRows = grid.element.find(
				".transaction-checkbox:not([disabled])"
			).length;
			const selectedCheckableRows = grid.element.find(
				".transaction-checkbox:not([disabled]):checked"
			).length;
			grid.element
				.find(".select-all-checkbox")
				.prop(
					"checked",
					totalCheckableRows > 0 &&
						totalCheckableRows === selectedCheckableRows
				);
		},
		refreshGrid(gridRef) {
			const grid = this.$refs[gridRef]?.kendoWidget();
			if (grid) {
				grid.dataSource.read();
			}
		}
	}
};
</script>

<style>
.popup {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 1000;
}

.popup-content {
	background: white;
	padding: 2rem;
	border-radius: 8px;
	text-align: center;
	max-width: 500px;
	width: 90%;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.button-group {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	margin-top: 1.5rem;
}

.button {
	padding: 0.75rem 1.5rem;
	border: none;
	border-radius: 4px;
	font-weight: 500;
	cursor: pointer;
	transition: opacity 0.2s;
}

.button:hover {
	opacity: 0.9;
}

.confirm {
	background-color: #dc3545;
	color: white;
}

.update {
	background-color: #fd7e14;
	color: white;
}

.close {
	background-color: #6c757d;
	color: white;
}

.mb-3 {
	margin-bottom: 1rem;
}

.mb-4 {
	margin-bottom: 1.5rem;
}
</style>
